import {
  GET_DASHBOARD_INFO, GET_DASHBOARD_OVERVIEW,
} from '../actionTypes';

const initialState = {
  isLoading: false,
  error: false,
  message: '',
  data: {},
  overview: {
    request: {
      in: { total: 0, percent: 0 },
      out: { total: 0, percent: 0 },
      cancel: { total: 0, percent: 0 },
    },
    order: {
      bid: { total: 0, percent: 0 },
      transaction: { total: 0, percent: 0 },
      bid_active: { total: 0, percent: 0 },
      sale: { total: 0, percent: 0 },
      seller: { total: 0, percent: 0 },
    },
    wallet: {
      revenue: { total: 0, percent: 0 },
      user: { total: 0, percent: 0 },
    },
    storage: { available: 0, used: 0, total: 0 },
    courier: { available: 0, used: 0, total: 0 },
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_DASHBOARD_INFO}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_DASHBOARD_INFO}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_DASHBOARD_INFO}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        data: payload.data.data,
      };
    case `${GET_DASHBOARD_OVERVIEW}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_DASHBOARD_OVERVIEW}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_DASHBOARD_OVERVIEW}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        overview: payload.data.data,
      };

    default:
      return state;
  }
}
